/**
 * Lightweight "n unit ago" formatter — no dep on a date library.
 *
 * The Inbox UI renders this label on every row; we keep it cheap and
 * deterministic. Anything older than a week is rendered with the
 * date in ISO-prefix form (YYYY-MM-DD) since "27d ago" stops being
 * useful past that boundary.
 */
export function timeAgo(iso: string | null, now: Date = new Date()): string {
  if (!iso) {
    return '—';
  }
  const then = new Date(iso);
  const diffMs = now.getTime() - then.getTime();
  if (Number.isNaN(diffMs)) {
    return '—';
  }
  const minutes = Math.floor(diffMs / 60_000);
  if (minutes < 1) {
    return 'just now';
  }
  if (minutes < 60) {
    return `${minutes}m ago`;
  }
  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return `${hours}h ago`;
  }
  const days = Math.floor(hours / 24);
  if (days < 7) {
    return `${days}d ago`;
  }
  return iso.slice(0, 10);
}

export function formatWakeAt(iso: string | null): string {
  if (!iso) {
    return '—';
  }
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) {
    return '—';
  }
  // YYYY-MM-DD HH:mm local time.
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
